module.exports = __webpack_public_path__ + "img/load.fa91e5de.gif";